import PaymentMethod from './PaymentMethod';

export type * from './interfaces';
export default PaymentMethod;
